export const isRewardOrder = (order) =>
  order?.metadata?.orderType === 'reward' &&
  Array.isArray(order?.metadata?.rewards);

export const getRewardOrderTotalPoints = (order) => {
  if (!order) return 0;
  const fromLines = (order.metadata?.rewards || []).reduce(
    (sum, line) => sum + (Number(line.subtotalPoints) || 0),
    0
  );
  if (fromLines > 0) return fromLines;
  return Number(order.price) || 0;
};

export const getItemFulfillmentDisplay = (status) => {
  if (status === 'delivered') {
    return { label: 'Ritirato', colorScheme: 'green' };
  }
  if (status === 'cancelled') {
    return { label: 'Annullato', colorScheme: 'gray' };
  }
  return { label: 'Da ritirare', colorScheme: 'orange' };
};

export const getOrderFulfillmentSummary = (order) => {
  const rewards = order?.metadata?.rewards || [];
  if (!rewards.length) {
    return getItemFulfillmentDisplay(
      order?.metadata?.rewardFulfillmentStatus || 'reserved'
    );
  }
  const statuses = rewards.map((r) => r.fulfillmentStatus || 'reserved');
  if (statuses.every((s) => s === 'delivered')) {
    return { label: 'Ritirato', colorScheme: 'green' };
  }
  if (statuses.every((s) => s === 'cancelled')) {
    return { label: 'Annullato', colorScheme: 'gray' };
  }
  if (statuses.some((s) => s === 'delivered')) {
    return { label: 'Parzialmente ritirato', colorScheme: 'yellow' };
  }
  return { label: 'Da ritirare', colorScheme: 'orange' };
};

export const orderHasPendingPickup = (order) => {
  const rewards = order?.metadata?.rewards || [];
  if (!rewards.length) {
    const status = order?.metadata?.rewardFulfillmentStatus || 'reserved';
    return status !== 'delivered' && status !== 'cancelled';
  }
  return rewards.some(
    (r) =>
      r.fulfillmentStatus !== 'delivered' && r.fulfillmentStatus !== 'cancelled'
  );
};

export const filterRewardOrders = (orders = []) =>
  orders.filter((order) => isRewardOrder(order) && !order.tesseramento);

/** Immagine premio da metadata ordine o lookup catalogo (rewardId → image). */
export const resolveRewardLineImage = (rewardLine, imageByRewardId = {}) => {
  if (!rewardLine) return null;
  if (rewardLine.image) return rewardLine.image;
  const id = rewardLine.rewardId;
  return id ? imageByRewardId[id] || null : null;
};
